export const getFileKeyFromUrl = (url: string) =>
  url.split('/')[3].split('?')[0];
